import {
  type FlowDocumentExtractBlockConfig,
  FlowDocumentExtractBlockConfigSchema,
  FlowLookbackDurationUnit,
  FlowProducedType,
} from 'flow-schema';

import { DocumentExtractFormFields } from './FormFields';
import { documentExtractDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { type BlockConfigProps } from '../../types';

export const documentExtractConfig: BlockConfigProps<FlowDocumentExtractBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'documentExtract',
  defaultConfig: {
    patient: {
      sourceBlockName: '',
      consumesType: FlowProducedType.Patient,
    },
    titleFilters: [],
    typeFilters: [],
    documentLimit: 10,
    lookbackDuration: {
      value: 10,
      unit: FlowLookbackDurationUnit.Years,
    },
    encounterId: undefined,
  },
  configFields: {
    getLanguageFieldValues: (config) => {
      return {
        [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.encounterId],
      };
    },
    schema: FlowDocumentExtractBlockConfigSchema,
    FormFields: DocumentExtractFormFields,
  },
  documentationMarkdown: documentExtractDocumentationMarkdown,
};
